export default {
  "brand.name": "USFansSheet",
  "brand.tagline": "Spreadsheet Hub",

  "nav.spreadsheet": "Spreadsheet",
  "nav.finds": "Finds",
  "nav.guides": "Guides",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.coupons": "Coupons",
  "nav.warehouse": "Warehouse",
  "nav.safety": "Safety",
  "nav.faq": "FAQ",
  "nav.home": "Home",
  "nav.buyingGuide": "Buying Guide",
  "mobile.categories": "Browse Categories",

  "hero.badge": "Updated 2026 resources",
  "hero.title": "USFans Spreadsheet — Find Smarter, Buy With Confidence",
  "hero.subtitle": "The smarter way to explore USFans finds. Discover organized spreadsheets, W2C links, product guides, QC tips, shipping information and buying resources — all in one place.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "buy it now",
  "hero.trust": "Updated resources · Buying guides · QC education · Shipping information",

  "stats.resources": "Resources",
  "stats.categories": "Categories",
  "stats.guides": "Guides",
  "stats.languages": "Languages",

  "dropdown.label": "Browse categories",
  "dropdown.placeholder": "Choose a category to explore",

  "categories.title": "USFans Spreadsheet Categories",
  "categories.subtitle": "Jump straight to any category on the main store — organized so you can compare listings faster.",

  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies / Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants / Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear / Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",

  "articles.title": "Popular USFans Spreadsheet Guides",
  "articles.subtitle": "Original, research-first articles to help you understand the process before you order.",
  "articles.readMore": "Read guide",
  "articles.viewAll": "View all guides",

  "article.1.title": "What Is the USFans Spreadsheet? Complete 2026 Guide",
  "article.1.excerpt": "A clear breakdown of what the USFans Spreadsheet is, how it works, and how to use it to research products, compare listings and understand QC before ordering.",

  "guides.title": "USFans Guides & Resources",
  "guides.subtitle": "Dive into review, shipping, coupon, warehouse and safety topics before you order.",
  "guides.learnMore": "Read guide",
  "guides.1.title": "USFans Review",
  "guides.1.desc": "A balanced look at the buying experience and what to consider.",
  "guides.2.title": "USFans Shipping Cost",
  "guides.2.desc": "Understand weight, lines and destination before you ship.",
  "guides.3.title": "USFans Coupon",
  "guides.3.desc": "Find and verify the latest coupon and discount offers.",
  "guides.4.title": "USFans Discount Code",
  "guides.4.desc": "How discount codes work and what to watch for.",
  "guides.5.title": "USFans Warehouse",
  "guides.5.desc": "QC, storage and consolidation explained simply.",
  "guides.6.title": "Is USFans Legit?",
  "guides.6.desc": "Safety checks and red flags to research first.",
  "article.2.title": "USFans Review 2026 – Is It Worth Using?",
  "article.2.excerpt": "A balanced review of the USFans buying experience — what to expect, the pros and considerations, and who it works best for.",
  "article.3.title": "USFans Shipping Cost Guide 2026",
  "article.3.excerpt": "How USFans shipping cost is calculated by weight, line and destination, plus practical ways to estimate and reduce it.",
  "article.4.title": "USFans Coupon & Discount Code Guide",
  "article.4.excerpt": "Where to find USFans coupons and discount codes, how to verify they are current, and common mistakes to avoid.",
  "article.5.title": "USFans Warehouse Guide 2026",
  "article.5.excerpt": "How the USFans warehouse handles QC, storage and parcel consolidation before international shipping.",
  "article.6.title": "Is USFans Legit in 2026?",
  "article.6.excerpt": "A balanced safety guide on how to evaluate sellers, spot red flags and research before you order.",
  "article.7.title": "USFans W2C Links Guide",
  "article.7.excerpt": "What W2C means, how W2C links work inside the spreadsheet, and how to use them safely.",
  "article.8.title": "USFans QC Guide – How to Read QC Photos",
  "article.8.excerpt": "Learn what to inspect in QC photos — stitching, labels, color and proportions — before your item ships.",
  "article.9.title": "USFans Buying Guide 2026",
  "article.9.excerpt": "A step-by-step buying guide covering research, ordering, QC, payment and shipping in the right order.",
  "article.10.title": "How to Use the USFans Spreadsheet",
  "article.10.excerpt": "A beginner-friendly walkthrough of the spreadsheet's categories, columns and how to turn finds into orders.",
  "article.11.title": "USFans Spreadsheet Finds Guide",
  "article.11.excerpt": "What 'finds' are, the most popular categories, and how to spot a good one before you commit.",

  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers about the USFans Spreadsheet and how the buying process works.",
  "faq.q1": "What is the USFans Spreadsheet?",
  "faq.a1": "The USFans Spreadsheet is an organized research resource that helps shoppers discover products, compare listings, review available information and understand the buying process before placing an order.",
  "faq.q2": "Is USFans legit?",
  "faq.a2": "We provide balanced, research-based information to help you evaluate sellers and listings for yourself. Always verify the current listing, seller and shipping terms before purchasing.",
  "faq.q3": "How does USFans work?",
  "faq.a3": "It typically works through a shopping agent or forwarder model: you research products, submit links, review QC photos and then arrange international shipping to your country.",
  "faq.q4": "How much does USFans shipping cost?",
  "faq.a4": "Shipping cost depends on parcel weight, dimensions, shipping line and destination country. Check the shipping guide and current rates before ordering, as estimates can vary.",
  "faq.q5": "Where can I find USFans coupons?",
  "faq.a5": "Coupon and discount availability changes often. Always check the latest verified offers and their expiration dates before relying on them.",

  "safety.title": "Research First. Order Smarter.",
  "safety.body": "A spreadsheet can help you research products, but no listing can guarantee product quality, seller reliability, availability or shipping results. Always verify current information before ordering.",

  "finalCta.title": "Ready to Explore USFans?",
  "finalCta.body": "Browse the spreadsheet, learn the process and continue to the main website when you're ready.",
  "finalCta.button": "Explore USFans Resources",

  "footer.resources": "Resources",
  "footer.company": "Company",
  "footer.legal": "Legal",
  "footer.language": "Language",
  "footer.about": "About",
  "footer.methodology": "Methodology",
  "footer.editorial": "Editorial Policy",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.disclaimer": "Disclaimer",
  "footer.rights": "All rights reserved.",
  "footer.disclaimerText": "Information is for research and educational purposes. Product availability, prices and shipping conditions can change. Always verify current information before purchasing.",

  "article.meta": "Complete 2026 guide to the USFans Spreadsheet — what it is, how it works, and how to use it for finds, W2C links, QC and shipping.",
  "article.backHome": "Back to home",
  "article.updated": "Last updated",
  "article.readTime": "min read",
  "article.toc": "Table of contents",
  "article.notFound": "Article not found",
  "article.related": "Want to explore the organized categories? Head back to the USFansSheet home page to browse the full category list, or continue to the main store below.",
};